<template>
  <VWidget :title="$t('Documents')">
    <div slot="widget-content">
      <v-list two-line>
        <template v-for="document in order.documents">
          <v-list-tile
            :key="document.id"
          >
            <v-list-tile-content>
              <v-list-tile-title class="text-capitalize">{{ document.type | type }} #{{ document.number }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ $t('Created At') }}: {{ document.created_at | timezone }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                :disabled="loading && loadingDocument !== document.id"
                :loading="loadingDocument === document.id"
                icon
                color="primary"
                @click="print(document)"
              >
                <v-icon>print</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </div>
  </VWidget>

</template>

<script>
export default {
  name: 'OrderSingleDocuments',

  filters: {
    type: function (arg) {
      return arg.replace('_', ' ')
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      loadingDocument: null
    }
  },

  methods: {
    print (doc) {
      const shouldDownload = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

      this.loading = true
      this.loadingDocument = doc.id
      this.order.printDocument(doc, shouldDownload).catch(e => {
        this.$toast.error(this.$t(e.message))
      }).finally(() => {
        this.loading = false
        this.loadingDocument = null
      })
    }
  }
}
</script>
